<template>
  <UiNarrowContainer class="py-28">
    <UiHeading v-if="content.title" type="h1" class="mb-8 text-center">{{ content.title }}</UiHeading>
    <div
      :class="[
        'flex flex-col items-center rounded-xl md:flex-row',
        { 'flex-col-reverse md:flex-row-reverse': content.image_position === 'right' },
        { 'space-y-12 p-12 md:space-x-12': content.padding === 'medium' },
        { 'space-y-4 p-4 md:space-x-4': content.padding === 'small' },
        { 'bg-gray-100': content.background_color === 'gray' },
        { 'bg-white': content.background_color === 'white' },
      ]"
    >
      <div class="flex items-center justify-center md:w-1/2">
        <UiImage
          :id="`text-with-image-${content.id}`"
          :alt="content.image.alt_text ?? content.id.toString()"
          :src="content.image.url"
          :class="[
            'rounded-xl',
            { 'w-full': content.image_size === 'large' },
            { 'w-2/4': content.image_size === 'medium' },
            { 'w-1/6': content.image_size === 'small' },
          ]"
        />
      </div>
      <div class="md:w-1/2">
        <UiRichTextContent :content="content.content" />
        <UiButton v-if="content.cta" :id="`text-with-image-${content.id}-cta`" :variant="content.cta.type">
          {{ content.cta.title }}
        </UiButton>
      </div>
    </div>
  </UiNarrowContainer>
</template>

<script setup lang="ts">
import type { PageTextWithImageProps } from '~/components/Page/types';

defineProps<PageTextWithImageProps>();
</script>
